// src/pages/LoginPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // لاگین ساده
    if (username === "admin" && password === "123456") {
      localStorage.setItem("admin_logged_in", "true"); // ذخیره لاگین
      navigate("/admin"); // برو به ادمین
    } else {
      setError("نام کاربری یا رمز عبور اشتباه است");
    }

    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-box glass">
        <h2>🍽️ ورود به پنل مدیریت</h2>

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="نام کاربری"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="رمز عبور"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && <p className="error">{error}</p>}

          <button type="submit" disabled={loading}>
            {loading ? "در حال ورود..." : "ورود"}
          </button>
        </form>
      </div>
    </div>
  );
}
